export default __webpack_public_path__ + "static/media/spinWheel.60e48a36.svg";